export default{
	appName: process.env.VUE_APP_NAME,
	emptyModel:function (source,excludeKeys){ //source将指定对象清空，excludeKeys有些key需要保留
		let me = this;			
		var sourceEmpty = source instanceof Array ? [] : {};
		if(source == null) sourceEmpty = null; 
		for (var item in source) {
			let b = false;
			if(excludeKeys && excludeKeys.length>0){
				for(let i=0;i<excludeKeys.length;i++){
					if (item == excludeKeys[i] ){
						b =true;
						break;
					}
				}
			}
			if(b) {
				sourceEmpty[item] = source[item] ;
			}else{
				if(source[item] instanceof Array ) 
					sourceEmpty[item] = [];
				else
					sourceEmpty[item] = typeof source[item] === 'object' ? me.emptyModel(source[item],excludeKeys) : '';
			}
		}
        return sourceEmpty;
	},
	//列表状态处理
	formatState(row){        
		if(row.state=='Y'){
			return '使用中'
		}else if(row.state=='N'){
			return '停用中'
		}
	},
	
	getItemByKeyVal(list,key,val,childKey){
		let obj = null;
		for(let i=0;i<list.length;i++){
			let item = list[i];
			if(item[key] == val){
				obj = item;
				break;
			}
			if(item[childKey] && item[childKey].length>0){
				obj= this.getItemByKeyVal(item[childKey],key,val,childKey);
				if(obj){
					break;
				}
			}
		}
		if(obj)
			return obj;
	},
	//获取当前用户信息
	getCurrUser:function(){
		return JSON.parse( window.sessionStorage.getItem("suser"));
	},
	getCurrUserRoleList:function(){
		return JSON.parse( window.sessionStorage.getItem("suserRoleList"))
	},
	getVbyK(list,value,key,value1){
		let name='';
		for(let i=0;i<list.length;i++){
			let item = list[i];
			if(item[key]== value){
				name=item[value1];
				break;
			}                    
		}            
		return name;
	},
	//集合转化成同一属性
	conversionList(list,key,toKey,value,toVal){
		let list1=[]
		for(let i=0;i<list.length;i++){	
			let obj={}
			obj[toKey]=list[i][key];
			obj[toVal]=list[i][value];
			list1.push(obj);
		}
		return list1;
	},
	//格式化金额
	formatPrice(value){
		if(value){
		  let  val = value.toString().replace(/\$|\,/g, "");
		  if (isNaN(val))
		  {
			val = "0";
		  }
		  let sign = (val == (val = Math.abs(val)));
		  val = Math.floor(val * 100 + 0.50000000001);
		  let cents = val % 100;
		  val = Math.floor(val / 100).toString();
		  if (cents < 10)
		  {
			  cents = "0" + cents;
		  }
		  for (let i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++)
		  {
			  val = val.substring(0, val.length - (4 * i + 3)) + "," + val.substring(val.length - (4 * i + 3));
		  }

		  return (((sign) ? "" : "-") + val + "." + cents);
		}
		  

	  },

}